import { render } from "./RegistrationPoliciesPage.vue?vue&type=template&id=792cc846&ts=true"
import script from "./RegistrationPoliciesPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPoliciesPage.vue?vue&type=script&lang=ts"

import "./RegistrationPoliciesPage.vue?vue&type=style&index=0&id=792cc846&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__